const contactAdvisersContainer = document.querySelector('.ContactAdvisers');
const ACTIVE_CLASS_NAME = 'active';

function removeActiveClass(items) {
    items?.forEach((el) => el.classList.remove(ACTIVE_CLASS_NAME));
}

const navItems = contactAdvisersContainer?.querySelectorAll('.ContactAdvisers__nav a');
const tabs = contactAdvisersContainer?.querySelectorAll('.ContactAdvisers__tabs > div');

navItems?.forEach((item, index) => {
    item.addEventListener('click', (e) => {
        e.preventDefault();

        removeActiveClass([...navItems, ...tabs]);
        item.classList.add(ACTIVE_CLASS_NAME);
        tabs[index].classList.add(ACTIVE_CLASS_NAME);
    });
});
